/*
 * @Author: 窦云飞 df1987131@yeah.net
 * @Date: 2023-09-27 16:45:33
 * @LastEditors: 窦云飞 df1987131@yeah.net
 * @LastEditTime: 2024-03-22 15:20:48
 * @FilePath: /epec-purchase-shopping-mall/Users/douyunfei/Documents/epec-ea/src/modules/projectA/api/home/index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import request from '../request';

const urlPre = '/user-center';
const server = {
  // 首页-校验是否开通易支付
  queryOpeningPayment(params) {
    return request.post(`${urlPre}/user/queryOpeningPayment`, params);
  },
  // 首页-校验是否开通易认证
  queryOpeningAuthentication(params) {
    return request.post(`${urlPre}/user/queryOpeningAuthentication`, params);
  },
  // 首页-查询公司标准指数
  queryCompanyGradeInfo(params) {
    return request.post(`${urlPre}/user/queryCompanyGradeInfo`, params);
  },
  // 获取用户菜单集合
  getAllMeunList(params) {
    return request.post(`/ubm/member/queryBackMenuList`, params);
  },
  // 获取易派客 易系列
  querySeriessSummary(params) {
    return request.fetch(`/user-center/company/querySeriessSummary`, params);
  },
  // 留言板
  queryPageForCompany(params) {
    return request.post(
      `/user-center/messageBoard/queryPageForCompany`,
      params,
      { preventRepeat: false }
    );
  },
  // 删除留言
  deleteMessage(params) {
    return request.post(`/user-center/messageBoard/delete`, params);
  },
  // 查询回复列表
  queryReplyList(params) {
    return request.post(`/user-center/messageBoard/queryReplyList`, params);
  },
  // 回复留言
  replyMessage(params) {
    return request.post(`/user-center/messageBoard/reply`, params);
  },
  // 获取订单数量
  logisticsCenterCountOrder(params) {
    return request.post(
      `transaction-center/supplier/logisticsCenterCountOrder`,
      params
    );
  },
  // 获取采购订单
  purchaseListOrder(params) {
    return request.post(`transaction-center/purchase/listOrder`, params, {
      preventRepeat: false,
    });
  },
  // 获取销售订单
  supplierListOrder(params) {
    return request.post(`transaction-center/supplier/listOrder `, params);
  },
};

export default server;
